angular.module('jv.bulkSelfSchedule.controller', [])
    .controller('jvBulkSelfScheduleController', ['$scope', '$rootScope', 'TemplateLoader', 'jvCandidatesService', '$q', '$jobviteUrls', '$timeout', 'jvHireBroadcastSVC', 'jvInterviewService', '$localStorage', '$window', 'candidates', '$log',
        function ($scope, $rootScope, TemplateLoader, jvCandidatesService, $q, $jobviteUrls, $timeout, jvHireBroadcastSVC, jvInterviewService, $localStorage, $window, candidates, $log) {
            jvHireBroadcastSVC.subscribe('showBulkCSSModal', function (event, value) {
                $scope.action = 'bulkSelfSchedule';
                $scope.validateCandidateDetails(value);
                initialize();
            });

            $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
            $scope.jvUrls = $jobviteUrls;
            $scope.bulkSchedule = true;
            var i18n;
            if ($.isEmptyObject($scope.i18n)) {
                //Candidate list page does not have i18n
                i18n = {
                    TO: 'To',
                    TEMPLATE: 'Template',
                    COMPANY: 'Company',
                    SUBJECT: 'Subject',
                    ANONYMOUS_TOOLTIP_TEXT: 'Choose the Send Anonymously option if you do not want the candidate to see your name or email address. Note that the candidate will still be able to reply to your message.',
                };
            } else {
                i18n = angular.copy($scope.i18n);
            }

            var TEMPLATE_ORDER = [
                'requestAvailabilityTemplate',
                'requestAvailabilityTemplateSMS',
                'scheduleTemplate',
                'inviteTemplate',
                'forwardSchedule'
            ];

            //var USERS = {};
            //var MEETING_ROOMS = [];
            //var ENTITY_ID_NAME = {};
            //var ENTITY_NAME = {};
            //var REQUESTED_TIME_SLOTS_DAYS = {};
            //var RESTORED_EVENTS_DATES = [];
            //var TIMEKEEPER = {};
            var i = 0;
            //var MEETING_ROOMS_CHECK = 0;
            var MEETING_ROOMS_DEFAULT = {
                rooms: [],
                added: null,
                removed: null
            };
            $scope.scheduler = {};
            $scope.scheduler.showDialog = false;
            $scope.scheduler.loading = [];
            $scope.scheduler.mode = 'REQUEST';
            $scope.scheduler.interviewersExpand = true;
            $scope.scheduler.overrideInterviewDuration = 0;
            $scope.scheduler.selectedInterviewDuration = '30';
            $scope.scheduler.overallSlotCount = 0;
            $scope.scheduler.autoDisabled = true;
            $scope.scheduler.meetingroomBlock = false;
            $scope.scheduler.request = {};
            $scope.scheduler.meetingRoomEnabled = false;
            $scope.scheduler.minimumCandTimeslot = '1';
            $scope.scheduler.interviewersList = [];
            $scope.videoConferencingProperties = {};
            $scope.videoConferencingProperties.includeConferenceLink = jvInterviewService.getIncludeConferenceLink();
            $scope.videoConferencingProperties.videoConferenceEnabled = $window.videoConferenceEnabled;
            $scope.enableSMSMessaging = false;
            $scope.enableSMSToggle = false;
            $scope.scheduler.deliveryMethod = 'EMAIL';
            $scope.displayBothRCA = false;
            $scope.phoneList = {
                fromPhoneData: {
                    label: i18n['FROM'],
                    required: true,
                    errorText: i18n['JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                    data: {
                        type: 'dropDown',
                        key: 'sendMsgFrom',
                        name: 'fromList',
                        optionsValues: []
                    }
                }
            };
            var getInterviewerInfo = function () {
                var messageToList = [];
                var interviewers = [];

                interviewers = jvInterviewService.getInterviewers();
                for (var interviewer in interviewers) {
                    messageToList.push(interviewers[interviewer].fullName);
                }
                $scope.messager.messageToList = messageToList.join(', ') || '-';

                return interviewers;
            };

            var getCalendarDateRange = function () {
                var view = $('#scheduler-calendar').fullCalendar('getView');
                return {
                    start: angular.copy(view.start).day(0),
                    end: angular.copy(view.start).day(6)
                };
            };

            $scope.changeDuration = function () {
                $scope.scheduler.overrideInterviewDuration = 0;
                for (i = 0; i < $scope.scheduler.interviewersList.length; i++) {
                    $scope.scheduler.overrideInterviewDuration += parseInt($scope.scheduler.interviewersList[i].duration);
                }
            };

            var addLoading = function (loader) {
                $scope.messager.loading.push(loader);
                $scope.flags.loading = true;
            };

            var removeLoading = function (loader) {
                $scope.messager.loading.splice($scope.messager.loading.indexOf(loader), 1);
                if ($scope.messager.loading.length === 0) {
                    $scope.flags.loading = false;
                }
            };

            $scope.autoSendEnabled = true;

            var finaValidAppDetails = function (EId) {
                return $scope.applications.find(function (data) {
                    return data.EId === EId;
                });
            };

            var initialize = function () {
                $scope.modalList = {
                    to: {
                        label: i18n['TO'],
                        type: 'readOnlyLink',
                        data: {
                            type: 'link',
                            text: $scope.toList
                        }
                    }
                }

                $scope.messager = {};
                $scope.messager.loading = [];
                $scope.messager.templates = {};
                $scope.messager.scheduledDetails = {}
                $scope.messager.scheduledDetails.auto = true;
                $scope.messager.scheduledDetails.selectedInterviewWindow = 2;
                $scope.messager.scheduledDetails.interviewDurations = angular.copy(jvInterviewService.getBaseDuration());
                $scope.messager.scheduledDetails.selectedInterviewDuration = $scope.messager.scheduledDetails.interviewDurations[0].id;
                $scope.messager.scheduledDetails.meetingRooms = angular.copy(MEETING_ROOMS_DEFAULT);
                $scope.messager.includeConferenceLink = jvInterviewService.getIncludeConferenceLink();
                $scope.messager.videoConferenceEnabled = jvInterviewService.getVideoConferenceEnabled();
                $scope.videoConferencingProperties.showError = false;
                $scope.interviewWindowShowError = false;
                $scope.interviewersBlock = {};
                $scope.interviewersBlock.users = {
                    employees: [],
                    added: null,
                    removed: null
                }
            }

            $scope.getTemplateInfo = function () {
                var validAppDetails = '';
                var candidate = '';
                if($scope.validApplicationIds && $scope.validApplicationIds.length > 0) {
                    validAppDetails = finaValidAppDetails($scope.validApplicationIds[0]);
                    candidate = validAppDetails.fullName;
                } else if($scope.allApplicationsForSmsInvitationIds  && $scope.allApplicationsForSmsInvitationIds.length > 0) {
                    validAppDetails = finaValidAppDetails($scope.allApplicationsForSmsInvitationIds[0]);
                    candidate = validAppDetails.fullName;
                } else if($scope.allApplicationsForEmailInvitationIds && $scope.allApplicationsForEmailInvitationIds.length > 0) {
                    validAppDetails = finaValidAppDetails($scope.allApplicationsForEmailInvitationIds[0]);
                    candidate = validAppDetails.fullName;
                }

                var agencyCandidate = i18n['COMMON_CANDIDATE'] + ' (' + candidate + ')';
                var interviewers = $scope.messager.templates.scheduleTemplate ? $scope.messager.templates.scheduleTemplate.to : '-';

                if($scope.scheduler.deliveryMethod === 'SMS'
                   && $scope.validationResult.applicationsForEMAILInvitationCount && $scope.validationResult.applicationsForEMAILInvitationCount > 0
                   && $scope.validationResult.applicationsForSMSInvitationCount && $scope.validationResult.applicationsForSMSInvitationCount > 0) {
                   $scope.displayBothRCA = true;
                } else {
                    $scope.displayBothRCA = false;
                }

                addLoading('TemplateInfo');
                candidates.getRequestAvailabilityTemplate(
                    validAppDetails.jobEId,
                    validAppDetails.candidateState.EId,
                    {
                        autoSchedule: true,
                        messageType: $scope.scheduler.deliveryMethod ? $scope.scheduler.deliveryMethod : 'EMAIL',
                        invitationTypology: 'CSS'
                    },
                    function (templateResponse) {
                        for (var template in templateResponse.templates) {
                            if($scope.scheduler.deliveryMethod !== 'SMS') {
                                if(template !== 'requestAvailabilityTemplateSMS') {
                                    templateResponse.templates[template].showAvailability = (template === 'requestAvailabilityTemplate') ? true : false;
                                    for (var attachment in templateResponse.templates[template].attachments) {
                                        templateResponse.templates[template].attachments[attachment].include = true;
                                    }
                                    if (template === 'requestAvailabilityTemplate'|| template === 'inviteTemplate') {
                                        if (templateResponse.agencyCandidate) {
                                            templateResponse.templates[template].to = i18n['COMMON_AGENCY'] + ' (' + templateResponse.agency.fullName + ')';
                                            templateResponse.templates[template].toAgencyCandidate = agencyCandidate;
                                        } else {
                                            templateResponse.templates[template].to = candidate;
                                        }
                                        templateResponse.templates[template].includeCandidate = true;
                                        if (template === 'inviteTemplate') {
                                            templateResponse.templates[template].autoSendEnabled = true;
                                            if (typeof $localStorage.autoSendEnabled !== 'undefined') {
                                                templateResponse.templates[template].autoSendEnabled = $localStorage.autoSendEnabled;
                                            }
                                        }
                                    } else if (template === 'scheduleTemplate') {
                                        templateResponse.templates[template].to = interviewers;
                                        templateResponse.templates[template].customMeetingRoomSubject = false;
                                        templateResponse.templates[template].meetingRoomSubject = i18n['I18N_MEETING_ROOM_INVITES_PLACEHOLDER'];
                                    } else {
                                        templateResponse.templates[template].to = '-';
                                    }
                                }
                            } else {
                                if(template !== 'requestAvailabilityTemplate' || $scope.displayBothRCA) {
                                    if($scope.displayBothRCA && template === 'requestAvailabilityTemplate') {
                                        templateResponse.templates[template].showAvailability = true;
                                    } else {
                                        templateResponse.templates[template].showAvailability = (template === 'requestAvailabilityTemplateSMS') ? true : false;
                                    }
                                    if(template !== 'requestAvailabilityTemplateSMS') {
                                        for (var attachment in templateResponse.templates[template].attachments) {
                                            templateResponse.templates[template].attachments[attachment].include = true;
                                        }
                                    }
                                    if (template === 'requestAvailabilityTemplateSMS' && $scope.scheduler.deliveryMethod === 'SMS' || $scope.displayBothRCA
                                        || template === 'inviteTemplate') {
                                        templateResponse.templates[template].includeCandidate = true;
                                        if (template === 'inviteTemplate') {
                                            templateResponse.templates[template].autoSendEnabled = true;
                                            if (typeof $localStorage.autoSendEnabled !== 'undefined') {
                                                templateResponse.templates[template].autoSendEnabled = $localStorage.autoSendEnabled;
                                            }
                                        }
                                    } else if (template === 'scheduleTemplate') {
                                        templateResponse.templates[template].to = interviewers;
                                        templateResponse.templates[template].customMeetingRoomSubject = false;
                                        templateResponse.templates[template].meetingRoomSubject = i18n['I18N_MEETING_ROOM_INVITES_PLACEHOLDER'];
                                    } else {
                                        templateResponse.templates[template].to = '-';
                                    }
                                }
                            }
                        }

                        Object.assign($scope.messager, templateResponse);
                        if ($scope.messager.scheduledDetails.auto) {
                            Object.assign($scope.messager.templates, {
                                forwardSchedule: {
                                    showAvailability: true
                                }
                            });
                        }
                        $scope.messager.includeResume = $scope.messager.attachResume;
                        $scope.messager.includeCoverLetter = $scope.messager.attachCoverLetter;
                        $scope.messager.templateOrder = TEMPLATE_ORDER;
                        $scope.showModals($scope.action);

                        removeLoading('TemplateInfo');
                    }, function (templateErr) {
                        $log.error(templateErr);
                        removeLoading('TemplateInfo');
                    }
                );

            };

            var customApply = function () {
                var phase = $scope.$$phase;
                if (phase === null) {
                    $scope.$apply();
                }
            };
            // Modal Information
            $scope.modals = {
                sendMessageValidation: {
                    show: false,
                    allAppsInNonInterviewStatus: false
                },
                bulkSelfSchedule: {
                    show: false
                }
            };

            //Used to show the move modal
            $scope.showModals = function (modal, skipConfigSetup) {
                TemplateLoader.load(modal).then(function () {
                    $scope.modals[modal].show = true;
                    if (JV.Person) {
                        JV.Person.Global.grid.removeLoadingState();
                    }
                });
            };

            //Used to hide all the modals on the page
            $scope.hideModals = function () {
                angular.forEach($scope.modals, function (val, key) {
                    $scope.modals[key].show = false;
                });
                if (JV.Person) {
                    JV.Person.resetValues();
                }
            };

            $scope.templates = TemplateLoader.register({
                sendMessageValidation: '/jhire/modules/candidates/modals/sendMessageValidation.html',
                bulkSelfSchedule: '/jhire/modules/candidates/modals/bulkSelfSchedule.html',
                template: '/jhire/modules/candidates/interviewMessagerTemplates.html'
            });

            $scope.modifiedInterviewers = function (index, users) {
                var toList = [];
                users.employees.forEach(function (value, key) {
                    toList.push(value.fullName);
                })

                $scope.messager.templates.scheduleTemplate.to = toList.join(', ') || '-';
            };

            var pushToArrayIfNotExist = function (interviewers, interviewer) {
                var exists = $.map(interviewers, function (val) {
                    return val.EId === interviewer.EId ? interviewer.EId : null;
                });

                if (exists[0] !== interviewer.EId) {
                    interviewers.push(interviewer);
                }
                return interviewers;
            };

            $scope.validateCandidateDetails = function (data) {
                var postData = {};
                postData.action = 'bulkSelfSchedule';
                if (data) {
                    postData.data = data.appIds;
                    postData.deliveryMethod = $scope.scheduler.deliveryMethod;
                    $scope.appIds = postData.data;
                    $scope.isMultipleApplicationsSelected = postData.data.length > 1 ? true : false;
                } else {
                    postData.data = JV.Person.getSelectedAppIds();
                    $scope.isMultipleApplicationsSelected = postData.data.length > 1 ? true : false;
                }

                jvCandidatesService.validateCandidateDetails(postData, function (response) {
                    if (response && response.status === 200) {
                        var validationResult = $scope.validationResult = response.data;
                        var validAgencyApplicationCount = response.data.validAgencyApplicationCount,
                            validApplicationCount = response.data.validApplicationCount;
                        validationResult.unAuthorizedApplicationCountLink = '';
                        validationResult.unAuthorizedApplicationMsg = '';
                        validationResult.validApplicationCountLink = '';
                        validationResult.validAgencyApplicationCountLink = '';
                        validationResult.invalidApplicationCountLink = '';
                        validationResult.invalidAgencyApplicationCountLink = '';

                        validationResult.applicationsForSMSInvitationCountLink = '';
                        validationResult.applicationsForEMAILInvitationCountLink = '';
                        validationResult.agencyApplicationsForEmailInvitationCountLink = '';
                        validationResult.agencyApplicationsForSMSInvitationCountLink = '';
                        validationResult.applicationsForSkipCountLink = '';
                        validationResult.agencyApplicationsForSkipCountLink = '';
                        validationResult.applicationsForSMSInvitationMessage = '';
                        validationResult.applicationsForEMAILInvitationMessage = '';
                        validationResult.agencyApplicationsForEmailInvitationMessage = '';
                        validationResult.agencyApplicationsForSMSInvitationMessage = '';
                        validationResult.applicationsForSkipMessage = '';
                        validationResult.agencyApplicationsForSkipMessage = '';

                        $scope.enableSMSMessaging = $scope.validationResult.enableSMSMessaging;
                        $scope.enableSMSToggle = $scope.validationResult.enableSMSToggle;
                        $scope.enableEmailToggle = response.data.validApplicationCount > 0 || response.data.validAgencyApplicationCount > 0 ? true : false;

                        if(response.data.allApplicationsInNonInterviewStatus) {
                            $scope.modals.sendMessageValidation.allAppsInNonInterviewStatus = true;
                            $scope.showModals('sendMessageValidation', true);
                            return false;
                        } else if(response.data.validApplicationCount === 0 && validAgencyApplicationCount === 0 && response.data.allApplicationsForSmsInvitation.length === 0) {
                            $scope.showModals('sendMessageValidation', true);
                            return false;
                        }
                        if($scope.scheduler.deliveryMethod === 'EMAIL' && response.data.validApplicationCount === 0 && validAgencyApplicationCount === 0 && response.data.allApplicationsForSmsInvitation.length > 0) {
                            $scope.scheduler.deliveryMethod = 'SMS';
                        } else if($scope.scheduler.deliveryMethod === 'SMS' && response.data.allApplicationsForSmsInvitation.length === 0 && response.data.allApplicationsForEmailInvitation.length > 0) {
                            $scope.scheduler.deliveryMethod = 'EMAIL';
                        }

                        var candidateName;

                        if (JV.Person && JV.Person.getSelectedAppIds().length == 1) {
                            //only one candidate selected. Hence we show name
                            candidateName = JV.Person.getSelectedCandidateName();
                            if (validApplicationCount === 1) {
                                $scope.toList += '<span class="block">' + candidateName + '</span>';
                            } else {
                                if (validAgencyApplicationCount === 1) {
                                    $scope.toList += '<span class="block">' + candidateName;
                                    if (scope.action !== 'seekConsent') {
                                        $scope.toList += ' ' + i18n['JV_SENDMESSAGE_CONTROLLER_AGENCY_WILL_BE_CC_ED'] + '</span>';
                                    }
                                }
                            }
                        } else {
                            if($scope.scheduler.deliveryMethod !== 'SMS') {
                                //More than one candidate selected. We wont show name here only count.
                                if (validationResult.validApplicationCount) {
                                    validationResult.validApplicationCountLink = validationResult.validApplicationCount + ' ' + i18n['CANDIDATES_COMMON'];
                                }
                                if (validationResult.validAgencyApplicationCount) {
                                    if ($scope.action !== 'seekConsent') {
                                        validationResult.agencyCopied = i18n['CANDIDATES_AGENCY_NOTIFIED'];
                                    } else {
                                        validationResult.agencyCopied = '';
                                    }
                                    if (validationResult.validApplicationCount) {
                                        validationResult.commonAnd = i18n['COMMON_AND'];
                                    }
                                    validationResult.validAgencyApplicationCountLink = validationResult.validAgencyApplicationCount + ' ' + i18n['CANDIDATES_AGENCY_COMMON'];
                                }
                                if (validationResult.invalidApplicationCount || validationResult.invalidAgencyApplicationCount) {
                                    if (validationResult.invalidApplicationCount) {
                                        validationResult.invalidApplicationCountLink = validationResult.invalidApplicationCount + ' ' + i18n['CANDIDATES_COMMON'];
                                    }
                                    if (validationResult.invalidAgencyApplicationCount) {
                                        validationResult.commonAnd = i18n['COMMON_AND'];
                                        validationResult.invalidAgencyApplicationCountLink = validationResult.invalidAgencyApplicationCount + ' ' + i18n['CANDIDATES_AGENCY_COMMON'];
                                    }
                                    validationResult.skipMissingEmail = i18n['CANDIDATES_MISSING_EMAIL_OR_INVALID_STATUS'];
                                }
                                if (validationResult.unAuthorizedApplicationCount) {
                                    validationResult.unAuthorizedApplicationCountLink = validationResult.unAuthorizedApplicationCount + ' ' + i18n['CANDIDATES_COMMON'];
                                    validationResult.unAuthorizedApplicationMsg = i18n['CANDIDATES_SKIP_MSG'];
                                }
                                $scope.validApplicationIds = validationResult.validApplicationIds;
                            } else {
                                if (validationResult.applicationsForEMAILInvitationCount || validationResult.applicationsForSMSInvitationCount) {
                                    validationResult.validApplicationCount = validationResult.applicationsForEMAILInvitationCount ? validationResult.applicationsForEMAILInvitationCount : 0;
                                    validationResult.validApplicationCount += validationResult.applicationsForSMSInvitationCount ? validationResult.applicationsForSMSInvitationCount : 0;
                                    
                                    if (validationResult.validApplicationCount) {
                                        validationResult.validApplicationCountLink = validationResult.validApplicationCount + ' ' + i18n['CANDIDATES_COMMON'];
                                    }
                                }
                                if (validationResult.agencyApplicationsForEmailInvitationCount || validationResult.agencyApplicationsForSMSInvitationCount) {
                                    validationResult.validAgencyApplicationCount = validationResult.agencyApplicationsForEmailInvitationCount ? validationResult.agencyApplicationsForEmailInvitationCount : 0;
                                    validationResult.validAgencyApplicationCount += validationResult.agencyApplicationsForSMSInvitationCount ? validationResult.agencyApplicationsForSMSInvitationCount : 0;
                                    if (validationResult.validAgencyApplicationCount) {
                                        if ($scope.action !== 'seekConsent') {
                                            validationResult.agencyCopied = i18n['CANDIDATES_AGENCY_NOTIFIED'];
                                        } else {
                                            validationResult.agencyCopied = '';
                                        }
                                        if (validationResult.validApplicationCount) {
                                            validationResult.commonAnd = i18n['COMMON_AND'];
                                        }
                                        validationResult.validAgencyApplicationCountLink = validationResult.validAgencyApplicationCount + ' ' + i18n['CANDIDATES_AGENCY_COMMON'];
                                    }
                                }
                                if (validationResult.applicationsForEMAILInvitationCount && validationResult.applicationsForEMAILInvitationCount > 0) {
                                    $scope.allApplicationsForEmailInvitation = validationResult.applicationsForEMAILInvitation;
                                    if(validationResult.agencyApplicationsForEmailInvitationCount && validationResult.agencyApplicationsForEmailInvitationCount > 0) {
                                        $scope.allApplicationsForEmailInvitation = $scope.allApplicationsForEmailInvitation.concat(validationResult.agencyApplicationsForEmailInvitation);
                                    }
                                    validationResult.applicationsForEMAILInvitationCountLink = validationResult.applicationsForEMAILInvitationCount + ' ' + i18n['CANDIDATES_COMMON'];
                                    validationResult.applicationsForAllEMAILInvitationCountLink = $scope.allApplicationsForEmailInvitation.length + ' ' + i18n['CANDIDATES_COMMON'];
                                    validationResult.applicationsForEMAILInvitationMessage = i18n['MESSAGE_MISSING_MOBILE_SEND_EMAIL'];
                                }
                                if (validationResult.applicationsForSMSInvitationCount && validationResult.applicationsForSMSInvitationCount > 0) {
                                    validationResult.commonAnd = i18n['COMMON_AND'];
                                    $scope.allApplicationsForSMSInvitation = validationResult.applicationsForSMSInvitation;
                                    if(validationResult.agencyApplicationsForSMSInvitationCount && validationResult.agencyApplicationsForSMSInvitationCount > 0) {
                                        $scope.allApplicationsForSMSInvitation = $scope.allApplicationsForSMSInvitation.concat(validationResult.agencyApplicationsForSMSInvitation);
                                    }
                                    validationResult.applicationsForSMSInvitationCountLink = validationResult.applicationsForSMSInvitationCount + ' ' + i18n['CANDIDATES_COMMON'];
                                    validationResult.applicationsForAllSMSInvitationCountLink = $scope.allApplicationsForSMSInvitation.length + ' ' + i18n['CANDIDATES_COMMON'];
                                    validationResult.applicationsForSMSInvitationMessage = i18n['MESSAGE_CANDIDATE_SEND_SMS'];
                                }
                                if (validationResult.applicationsForSkipCount && validationResult.applicationsForSkipCount > 0) {
                                    validationResult.commonAnd = i18n['COMMON_AND'];
                                    validationResult.applicationsForSkipCountLink = validationResult.applicationsForSkipCount + ' ' + i18n['CANDIDATES_COMMON'];
                                    validationResult.applicationsForSkipMessage = i18n['MESSAGE_CANDIDATE_SKIPPED'];
                                }
                                if (validationResult.agencyApplicationsForSMSInvitationCount && validationResult.agencyApplicationsForSMSInvitationCount > 0) {
                                    validationResult.commonAnd = i18n['COMMON_AND'];
                                    validationResult.agencyApplicationsForSMSInvitationCountLink = validationResult.agencyApplicationsForSMSInvitationCount + ' ' + i18n['CANDIDATES_AGENCY_COMMON'];
                                    validationResult.agencyApplicationsForSMSInvitationMessage = i18n['MESSAGE_AGENCY_SEND_SMS'];
                                }
                                if (validationResult.agencyApplicationsForEmailInvitationCount && validationResult.agencyApplicationsForEmailInvitationCount > 0) {
                                    validationResult.commonAnd = i18n['COMMON_AND'];
                                    validationResult.agencyApplicationsForEmailInvitationCountLink = validationResult.agencyApplicationsForEmailInvitationCount + ' ' + i18n['CANDIDATES_AGENCY_COMMON'];
                                    validationResult.agencyApplicationsForEmailInvitationMessage = i18n['MESSAGE_MISSING_MOBILE_SEND_EMAIL_AGENCY'];

                                   if ($scope.action !== 'seekConsent') {
                                        validationResult.agencyCopied = i18n['CANDIDATES_AGENCY_NOTIFIED'];
                                    } else {
                                        validationResult.agencyCopied = '';
                                    }
                                    validationResult.commonAnd = i18n['COMMON_AND'];
                                    validationResult.copyAgencyApplicationCountLink = validationResult.agencyApplicationsForEmailInvitationCount + ' ' + i18n['CANDIDATES_AGENCY_COMMON'];
                                }
                                if (validationResult.agencyApplicationsForSkipCount && validationResult.agencyApplicationsForSkipCount > 0) {
                                    validationResult.commonAnd = i18n['COMMON_AND'];
                                    validationResult.agencyApplicationsForSkipCountLink = validationResult.agencyApplicationsForSkipCount + ' ' + i18n['CANDIDATES_AGENCY_COMMON'];
                                    validationResult.agencyApplicationsForSkipMessage = i18n['MESSAGE_AGENCY_SKIPPED'];
                                }

                                $scope.allApplicationsForSmsInvitationIds = validationResult.allApplicationsForSmsInvitation;
                                $scope.allApplicationsForEmailInvitationIds = validationResult.allApplicationsForEmailInvitation;
                            }
                            $scope.getTemplateInfo();
                            if (JV.Person) {
                                JV.Person.Global.grid.showLoadingState();
                            }
                        }

                    }
                });
            };

            /**
             * @method createBccList
             * @description Creates the bccList for email template
             * @param {Object} bcc list of Users
             * @returns {Object} bccList returns list of EIds
             */
            var createBccList = function (bcc) {
                var bccList = [];
                angular.forEach(bcc, function (value) {
                    bccList.push(value.EId);
                });
                return bccList;
            };

            /**
             * @method createAttachmentList
             * @description Creates the atachmentList for the uploads and attachments (Admin enabled) and assigns it to payload
             * @param {Object} template template from which the attachment list needs to be created
             * @returns {Object} list returns the attachment data
             */
            var createAttachmentList = function (template) {
                var list = [];
                angular.forEach(template.uploads, function (value, key) {
                    list.push(key);
                });
                angular.forEach(template.attachments, function (value) {
                    if (value.include) {
                        list.push(value.eid);
                    }
                });
                return list;
            };

            var createPayload = function () {
                var messager = $scope.messager;
                var templates = messager.templates;
                var appIds = $scope.scheduler.deliveryMethod !== 'SMS' ? $scope.validApplicationIds : $scope.allApplicationsForEmailInvitationIds;
                var appIdsSMS = $scope.allApplicationsForSmsInvitationIds;
                for (var employee in $scope.interviewersBlock.users.employees){
                    $scope.interviewersBlock.users.employees[employee].userEId = $scope.interviewersBlock.users.employees[employee].EId;
                }
                var interviewBlockData = {
                    interviewers: $scope.interviewersBlock.users.employees,
                    duration: parseInt(messager.scheduledDetails.selectedInterviewDuration),
                    order: 'ANY',
                    requiresMeetingRoom: $scope.messager.scheduledDetails.meetingRooms.rooms && $scope.messager.scheduledDetails.meetingRooms.rooms.length > 0,
                    host: $scope.interviewersBlock.users.employees[0] ? $scope.interviewersBlock.users.employees[0].EId : null,
                    useVC: messager.includeConferenceLink
                };
                var interviewerBlock = [interviewBlockData];
                var interviewers = [];

                var data = {
                    'templates': {},
                    'numberOfDays': messager.scheduledDetails.selectedInterviewWindow,
                    'totalDuration': parseInt(messager.scheduledDetails.selectedInterviewDuration),
                    'requestedScheduleSlots': [],
                    'applications': appIds,
                    'applicationsSms': appIdsSMS,
                    'interviewerBlock': interviewerBlock,
                    'meetingLocations': [],
                    'attachResume': messager.attachResume,
                    'attachCoverLetter': messager.attachCoverLetter,
                    'autoSchedule': messager.scheduledDetails.auto,
                    'useVC': messager.includeConferenceLink,
                    'deliveryMethod': $scope.scheduler.deliveryMethod,
                    'canvasChannelKey': $scope.phoneList && $scope.phoneList.fromPhone ? $scope.phoneList.fromPhone.canvasChannelKey : '',
                    'canvasOwnerId': $scope.phoneList && $scope.phoneList.fromPhone ? $scope.phoneList.fromPhone.canvasOwnerId : ''
                };

                if (angular.isDefined(templates.inviteTemplate) && templates.inviteTemplate.autoSendEnabled) {
                    // Interview Invitation To Candidate
                    data.templates.inviteTemplate = {
                        'bccList': createBccList(templates.inviteTemplate.bcc),
                        'content': templates.inviteTemplate.content,
                        'subject': templates.inviteTemplate.subject,
                        'forms': templates.inviteTemplate.forms,
                        'attachmentList': []
                    };
                    data.templates.inviteTemplate.attachmentList = createAttachmentList(templates.inviteTemplate);
                }

                if (angular.isDefined(templates.scheduleTemplate)) {
                    // Interview Invitation(s) To Interviewer(s)
                    data.templates.scheduleTemplate = {
                        'content': templates.scheduleTemplate.content,
                        'subject': templates.scheduleTemplate.subject,
                        'attachmentList': [],
                        'includeResume': $scope.messager.includeResume,
                        'includeCoverLetter': $scope.messager.includeCoverLetter
                    };

                    if (templates.scheduleTemplate.customMeetingRoomSubject) {
                        data.templates.meetingRoomTemplate = {
                            'subject': templates.scheduleTemplate.meetingRoomSubject
                        };
                    }

                    data.templates.scheduleTemplate.attachmentList = createAttachmentList(templates.scheduleTemplate);

                    if (angular.isDefined(templates.forwardSchedule)
                        && angular.isDefined(templates.forwardSchedule.to)
                        && templates.forwardSchedule.to.length > 0) {
                        var addedFwdRecipents = [];

                        for (var i = 0; i < templates.forwardSchedule.to.length; i++) {
                            addedFwdRecipents.push({
                                eid: templates.forwardSchedule.to[i].EId
                            });
                        }

                        data.templates.scheduleTemplate.addedFwdRecipents = addedFwdRecipents;
                        if (templates.forwardSchedule.calendarInvite) {
                            data.templates.scheduleTemplate.sendForwardInvite = templates.forwardSchedule.calendarInvite;
                        }
                    }
                }

                if (angular.isDefined(templates.requestAvailabilityTemplate)) {
                    // Availability Request To Candidate
                    data.templates.requestAvailabilityTemplate = {
                        'content': templates.requestAvailabilityTemplate.content,
                        'subject': templates.requestAvailabilityTemplate.subject,
                        'attachmentList': []
                    };

                    data.templates.requestAvailabilityTemplate.attachmentList = createAttachmentList(templates.requestAvailabilityTemplate);
                }

                if (angular.isDefined(templates.requestAvailabilityTemplateSMS)) {
                    // Availability Request To Candidate
                    data.templates.requestAvailabilityTemplateSMS = {
                        'content': templates.requestAvailabilityTemplateSMS.content
                    };
                }

                if($scope.scheduler.deliveryMethod !== 'SMS') {
                    data.notifyToAgencyOnlyMap = {}
                    for (let index = 0; index < $scope.validationResult.validApplications.length; index++) {
                        if ($scope.validationResult.validApplications[index].agencyApp) {
                            let appEId = $scope.validationResult.validApplications[index].EId;
                            data.notifyToAgencyOnlyMap[appEId] = {
                                requestAvailabilityNotifyToAgencyOnly: !templates.requestAvailabilityTemplate.includeCandidate,
                                inviteNotifyToAgencyOnly: !templates.inviteTemplate.includeCandidate
                            }
                        }
                    }
                } else {
                    data.notifyToAgencyOnlyMap = {}
                    for (let index = 0; index < $scope.validationResult.agencyApplicationsForEmailInvitation.length; index++) {
                        let appEId = $scope.validationResult.agencyApplicationsForEmailInvitation[index].EId;
                        data.notifyToAgencyOnlyMap[appEId] = {
                            inviteNotifyToAgencyOnly: !templates.inviteTemplate.includeCandidate
                        }
                    }
                }

                angular.forEach($scope.messager.scheduledDetails.meetingRooms.rooms, function (value) {
                    data.meetingLocations.push(value.EId);
                });

                return data;
            };

            /**
             * @method validateEmails
             * @description Validates the email templates for empty subject and body content
             * @param {object} template The email template object which needs to be validated.
             * @returns {boolean} true or false for valid/invalid template
             */
            var validateEmails = function (template, contentOnly) {
                if(contentOnly) {
                    return !template.content;
                } else {
                    return !template.subject || !template.content;
                }
            };

            /**
             * @method sendRequestDisabled
             * @description Validates the email templates - iterates though all the templates
             * @returns {boolean} true or false for valid/invalid template
             */
            $scope.sendRequestDisabled = function () {
                var isTemplateValid = false;
                angular.forEach($scope.messager.templates, function (value, key) {
                    if($scope.messager.templates.hasOwnProperty(key) && key === 'requestAvailabilityTemplateSMS' && !isTemplateValid) {
                        isTemplateValid = validateEmails(value, true);
                    } else if ($scope.messager.templates.hasOwnProperty(key) && key !== 'requestAvailabilityTemplateSMS' && key !== 'forwardSchedule' && !isTemplateValid) {
                        isTemplateValid = validateEmails(value, false);
                    }
                });
                return isTemplateValid ||
                    typeof ($scope.messager.scheduledDetails.selectedInterviewDuration) === 'undefined' ||
                    $scope.interviewersBlock.users.employees.length === 0;
            };

            $scope.bulkSelfScheduleCandidates = function () {
                var payload = createPayload();

                if (payload.numberOfDays === undefined){
                    $scope.interviewWindowShowError = true;
                    $scope.videoConferencingProperties.showError = false;
                }
                else if($scope.messager.includeConferenceLink ) {
                    $scope.interviewWindowShowError = false;
                    var hostEIds = [];
                    for(i=0; i< payload.interviewerBlock.length; i++){
                        if(payload.interviewerBlock[i].interviewers && payload.interviewerBlock[i].interviewers.length > 0){
                            hostEIds.push(payload.interviewerBlock[i].interviewers[0].EId);
                        }
                    }
                    if(hostEIds.length > 0) {
                        candidates.checkInterviewersVideoConferencingAccount(null, {userEIds: hostEIds}, function(res){
                            if(res && res.nonExistingAccounts && res.nonExistingAccounts.length > 0) {
                                $scope.flags.loading = false;
                                $scope.videoConferencingProperties.showError = true;
                                $scope.videoConferencingProperties.users = res.nonExistingAccounts.join(', ');
                            } else {
                                $scope.videoConferencingProperties.showError = false;
                                sendRequest(payload);
                            }
                        }, function(fail){
                            $log.error(fail);
                        });
                    } else {
                        sendRequest(payload);
                    }
                } else {
                    sendRequest(payload);
                }

            };

            var sendRequest = function(payload) {
                jvCandidatesService.bulkSelfSchedule(payload, function (response) {
                    if (response && response.status === 200) {
                        $rootScope.$broadcast('sendMessageSuccess', true);
                        if (JV.Person) {
                            JV.Person.Global.grid.removeLoadingState();
                            JV.Person.resetAfterActionUpdates();
                            var confirmationText = ($scope.validApplicationIds.length == '1') ? i18n['JV_SENDMESSAGE_CONTROLLER_MESSAGE_WAS_SENT_SUCCESSFULLY_TO_1_CANDIDATE'] : i18n['JV_SENDMESSAGE_CONTROLLER_MESSAGE_WAS_SENT_SUCCESSFULLY_TO_0_CANDIDATES'].format($scope.validApplicationIds.length);
                            JV.Util.showMessage(confirmationText);
                        }
                        $scope.hideModals();
                        if (JV.Person) {
                            JV.Person.Global.grid.showLoadingState();
                        }
                    }
                }, function (fail) {
                    $scope.flags.loading = false;
                });
            };

            var getPhoneNoList = function () {
                jvCandidatesService.getPhoneNoList({
                    data: {}
                }, function (resp) {
                    if (resp && resp.data && resp.data.phoneList && resp.data.phoneList.content) {
                        var phoneListContent = resp.data.phoneList.content;
                        var fromObj = angular.copy($scope.phoneList.fromPhoneData);
                        fromObj.data.optionsValues = [];
                        for (var phone of phoneListContent) {
                            // phoneForDisplay
                            const phoneData = {
                                label: phone.channelKey,
                                checked: true,
                                displayName: phone.owner.displayName + ' ' + phone.phoneForDisplay,
                                value: phone.channelKey,
                                canvasOwnerId: phone.owner.ownerRefKey,
                                canvasChannelKey: phone.channelKey
                            };
                            fromObj.data.optionsValues.push(phoneData);
                        }
                        $scope.phoneList.fromPhoneData.data.optionsValues = fromObj.data.optionsValues;
                        $scope.phoneList.fromPhone = fromObj.data.optionsValues[0];
                    }
                });
            };

            $scope.$watch('scheduler.deliveryMethod', function (newVal, oldVal) {
                if (!angular.isDefined(oldVal)) {
                    $scope.scheduler.deliveryMethod = 'EMAIL';
                } else if (angular.isDefined(oldVal) && newVal !== oldVal) {
                    $scope.scheduler.deliveryMethod = newVal;
                    var data = {};
                    data.appIds = $scope.appIds;
                    data.deliveryMethod = newVal;
                    $scope.validateCandidateDetails(data);
                    if ($scope.scheduler.deliveryMethod === 'SMS') {
                        getPhoneNoList();
                    }
                }
            });
        }
    ]);
